class CustomJsSelectBox {
    _selectNode = null;
    _isMultiple = true;
    _enableSearch = true;
    _enableCreation = false;
    _searchUrl = null;
    _activeGroup = null;
    _sanitizedSearchPhrase = '';

    _wrapperNode = null;
    _selectedNode = null;
    _searchNode = null;
    _createNewButtonNode = null;
    _noItemsNode = null;
    _searchingItemsNode = null;
    _searchingInstructionsNode = null;
    _itemsNode = null;
    _itemsNodes = [];

    _searchUrlXhr = null;
    _searchUrlTimeoutHandle = null;
    _searchUrlTimeoutDelay = 750;

    _limit = null;

    _isSmallViewPort = false;

    translations = {
        cs: {
            NoItems: 'Žádné položky',
            Searching: 'Vyhledávání',
            SearchingInstructions: 'Zadáním fráze začnete vyhledávat položky ...',
            SelectItems: 'Vyberte položky',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Dosažen maximální počet zvolených položek (%).',
            CreateNew: 'Vytvořit',
        },
        sk: {
            NoItems: 'Žiadne položky',
            Searching: 'Vyhľadávanie',
            SearchingInstructions: 'Zadajte frázu a začnite vyhľadávať položky ...',
            SelectItems: 'Vybrať položky',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Dosiahnutý maximálny počet vybraných položiek (%).',
            CreateNew: 'Vytvoriť',
        },
        en: {
            NoItems: 'No items',
            Searching: 'Searching',
            SearchingInstructions: 'Enter a phrase to start searching for items ...',
            SelectItems: 'Select items',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'The maximum number of selected items (%) has been reached.',
            CreateNew: 'Create',
        },
        fr: {
            NoItems: 'Aucun article',
            Searching: 'Chercher',
            SearchingInstructions: 'Saisissez une phrase pour lancer la recherche d\'articles ...',
            SelectItems: 'Sélectionnez des éléments',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Le nombre maximum d\'éléments sélectionnés (%) est atteint.',
            CreateNew: 'Créer',
        },
        it: {
            NoItems: 'Nessun articolo',
            Searching: 'Ricerca',
            SearchingInstructions: 'Immettere una frase per avviare la ricerca di articoli ...',
            SelectItems: 'Selezionare gli articoli',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Numero massimo di elementi selezionati (%) raggiunto.',
            CreateNew: 'Creare',
        },
        es: {
            NoItems: 'No hay artículos',
            Searching: 'Búsqueda',
            SearchingInstructions: 'Introduzca una frase para empezar a buscar artículos ...',
            SelectItems: 'Seleccione los artículos',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Número máximo de elementos seleccionados (%) alcanzado.',
            CreateNew: 'Cree',
        },
        de: {
            NoItems: 'Keine Artikel',
            Searching: 'Suche',
            SearchingInstructions: 'Geben Sie eine Phrase ein, um die Suche nach Artikeln zu starten ...',
            SelectItems: 'Artikel auswählen',
            TheMaximumNumberOfSelectedItemsXHasBeenReached: 'Maximale Anzahl ausgewählter Positionen (%) erreicht.',
            CreateNew: 'Maak',
        },
    };

    static init(selectNode) {
        if (selectNode) {
            return new CustomJsSelectBox(selectNode);
        }

        document.querySelectorAll('.js-custom-select:not(.js-select-initialized)').forEach(selectNode => {
            new CustomJsSelectBox(selectNode);
        });
    }

    static initSoloSelect(selectNode,notDisabled) {
        if (selectNode) {
            return new CustomJsSelectBox(selectNode,notDisabled);
        }
    }

    constructor(selectNode,notDisabled) {
        selectNode.customJsSelectBoxInstance = this;
        this._notDisabled = notDisabled;
        this._selectNode = selectNode;
        this._isMultiple = selectNode.multiple;
        this._enableSearch = selectNode.dataset.enableSearch !== 'false';
        this._enableCreation = selectNode.dataset.enableCreation === 'true';
        this._activeGroup = selectNode.dataset.group ? this._selectNode.dataset.group : null;
        this._limit = selectNode.dataset.limit ? parseInt(selectNode.dataset.limit) : null;

        this._searchUrl = selectNode.dataset.searchUrl;
        this._searchUrlTimeoutDelay = selectNode.dataset.searchUrlTimeoutDelay
            ? parseInt(selectNode.dataset.searchUrlTimeoutDelay)
            : this._searchUrlTimeoutDelay;

        this._initDocumentClickHandler();
        this._discoverItemsGroups()

        this._render();
        this._renderAvailableItems();
        this._updateOptionsAvailability();
        this._renderSelectedItems();
    }

    hasShownItems() {
        return ! this._itemsNode.hidden;
    }

    showItems() {
        if (this._selectNode.disabled && this._notDisabled) {
            return;
        }

        this._itemsNode.hidden = false;
        this._wrapperNode.classList.add('opened');
        if (window['customSelectBoxesOpenedInstance'] && window['customSelectBoxesOpenedInstance'].hasShownItems()) {
            window['customSelectBoxesOpenedInstance'].hideItems();
        }
        window['customSelectBoxesOpenedInstance'] = this;

        if (this._enableSearch) {
            document.addEventListener('keydown', this._swapKeyDownEvent);
        }

        if (this._searchUrl) {
            this._clearItems();
            this._noItemsNode.hidden = true;
            this._searchingInstructionsNode.hidden = false;
        } else {
            this._updateOptionsAvailability();
        }
    }
    hideItems() {
        this._itemsNode.hidden = true;
        this._wrapperNode.classList.remove('opened');
        window['customSelectBoxesOpenedInstance'] = null;

        window.removeEventListener('scroll', this.boundCalculateItemsPosition);

        if (this._enableSearch) {
            this._searchNode.value = '';
            this._sanitizedSearchPhrase = null;
            document.removeEventListener('keydown', this._swapKeyDownEvent);
        }

        if (this._searchUrl) {
            this._clearItems();
            this._searchingInstructionsNode.hidden = false;
        }

        if (this._enableCreation) {
            this._createNewButtonNode.hidden = true;
        }
    }

    switchGroup(group) {
        this._selectNode.dataset.group = group;
        this._activeGroup = group;

        this._updateOptionsAvailability();
        this._renderSelectedItems();

        if (self._enableSearch && self._searchUrl) {
            self._searchOnUrl();
        }
    }

    unselectItem(value) {
        for (let optionNode of this._selectNode.selectedOptions) {
            if (optionNode.value === value) {
                optionNode.selected = false;
            }
        }

        this._renderSelectedItems();
    }

    _initDocumentClickHandler() {
        if (window['customSelectInitializedDocumentClickHandler']) {
            return;
        }

        document.addEventListener('click', (event) => {
            if (! window['customSelectBoxesOpenedInstance']) {
                return;
            }

            if (
                ! window['customSelectBoxesOpenedInstance']._wrapperNode.contains(event.target)
                && window['customSelectBoxesOpenedInstance']._selectNode !== event.target
            ) {
                window['customSelectBoxesOpenedInstance'].hideItems();
            }
        });

        window['customSelectInitializedDocumentClickHandler'] = true;
    }

    _render() {
        let self = this;

        // main wrapper
        self._wrapperNode = document.createElement('div');
        self._wrapperNode.classList.add('c-custom-select');
        if (self._selectNode.multiple) {
            self._wrapperNode.classList.add('c-custom-select--multiple');
        }
        if (self._selectNode.disabled && self._notDisabled) {
            self._wrapperNode.classList.add('c-custom-select--disabled');
        }

        // selected items
        self._selectedNode = document.createElement('div');
        self._selectedNode.classList.add('c-custom-select__selected');
        self._selectedNode.onclick = () => {
            if (! self.hasShownItems()) {
                self.showItems();

                return;
            }

            self.hideItems();
        };

        // items
        self._itemsNode = document.createElement('div');
        self._itemsNode.classList.add('c-custom-select__items');
        self._itemsNode.hidden = true;

        // create new
        if (self._enableCreation) {
            self._createNewButtonNode = document.createElement('button');
            self._createNewButtonNode.classList.add('c-custom-select__crete-new-item-btn');
            self._createNewButtonNode.textContent = self._translate('CreateNew');
            self._createNewButtonNode.type = 'button';
            self._createNewButtonNode.hidden = true;
            self._createNewButtonNode.addEventListener('click', () => {
                let optionNode = document.createElement('option');
                optionNode.value = '_' + self._searchNode.value;
                optionNode.innerText = self._searchNode.value;
                self._selectNode.appendChild(optionNode);
                self._activateOption(optionNode);
                self._createNewButtonNode.hidden = true;
            });
            this._itemsNode.appendChild(this._createNewButtonNode);
        }

        // fake options - search bar
        if (self._enableSearch) {
            self._searchNode = document.createElement('input');
            self._searchNode.classList.add('c-custom-select__items-search');
            self._searchNode.type = 'search';
            self._searchNode.placeholder = self._translate('Searching');
            self._searchNode.oninput = () => {
                self._sanitizedSearchPhrase = self._sanitizeString(self._searchNode.value);
                self._wrapperNode.classList[self._sanitizedSearchPhrase ? 'add' : 'remove']('searching');

                if (self._enableCreation) {
                    self._createNewButtonNode.hidden = self._sanitizedSearchPhrase.length === 0;
                }

                if (self._searchUrl) {
                    self._searchOnUrl();
                } else {
                    self._updateOptionsAvailability();
                }
            }

            self._itemsNode.appendChild(self._searchNode);
        }

        // items - search bar
        self._noItemsNode = document.createElement('div');
        self._noItemsNode.classList.add('c-custom-select__items-ghost');
        self._noItemsNode.innerText = self._translate('NoItems');
        self._noItemsNode.hidden = true;

        self._searchingItemsNode = document.createElement('div');
        self._searchingItemsNode.classList.add('c-custom-select__items-ghost');
        self._searchingItemsNode.classList.add('c-custom-select__items-ghost--searching');
        self._searchingItemsNode.innerHTML = self._translate('Searching');
        self._searchingItemsNode.hidden = true;

        self._searchingInstructionsNode = document.createElement('div');
        self._searchingInstructionsNode.classList.add('c-custom-select__items-ghost');
        self._searchingInstructionsNode.innerHTML = self._translate('SearchingInstructions');
        self._searchingInstructionsNode.hidden = true;

        // build
        if (self._enableSearch) {
            self._itemsNode.appendChild(self._noItemsNode);
            self._itemsNode.appendChild(self._searchingItemsNode);
            self._itemsNode.appendChild(self._searchingInstructionsNode);
        }

        self._wrapperNode.appendChild(self._selectedNode);
        self._wrapperNode.appendChild(self._itemsNode);
        self._selectNode.parentNode.insertBefore(self._wrapperNode, self._selectNode.nextSibling);
        self._selectNode.classList.add('js-select-initialized');

        // hide original select node
        self._selectNode.style.setProperty('display', 'inline-block', 'important');
        self._selectNode.style.setProperty('height', '0', 'important');
        self._selectNode.style.setProperty('width', '0', 'important');
        self._selectNode.style.setProperty('padding', '0', 'important');
        self._selectNode.style.setProperty('border', '0', 'important');
        self._selectNode.style.setProperty('zIndex', '-1', 'important');
        self._selectNode.style.setProperty('outline', 'none', 'important');
        self._selectNode.style.setProperty('position', 'absolute', 'important');

        // transfer focus event on items
        self._selectNode.addEventListener('focus', () => {
            self._selectNode.blur();
            if (! self.hasShownItems()) {
                self.showItems();

            }

            self._itemsNode.focus();

            return false;
        });

        //hide items when focus out
        self._wrapperNode.addEventListener('focusout', () => {
            if(this._searchNode === event.target) {
                return;
            }

            self.hideItems();
        });

    }

    _clearItems() {
        this._itemsNodes.forEach(itemNode => {
            itemNode.remove();
        });
    }

    _searchOnUrl() {
        let self = this;

        if (self._searchUrlTimeoutHandle) {
            clearTimeout(self._searchUrlTimeoutHandle);
        }

        if (self._searchUrlXhr) {
            self._searchUrlXhr.abort();
        }

        let value = self._searchNode.value.trim();
        if (! value) {
            self._clearItems();
            self._noItemsNode.hidden = true;
            self._searchingItemsNode.hidden = true;
            self._searchingInstructionsNode.hidden = false;

            return;
        }

        self._clearItems();

        self._noItemsNode.hidden = true;
        self._searchingItemsNode.hidden = false;
        self._searchingItemsNode.innerText = self._translate('Searching') + ': "' + self._searchNode.value + '"';
        self._searchingInstructionsNode.hidden = true;

        self._searchUrlTimeoutHandle = setTimeout(function () {
            self._searchUrlXhr = new XMLHttpRequest();
            self._searchUrlXhr.open('post', self._searchUrl, true);
            self._searchUrlXhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            self._searchUrlXhr.onreadystatechange = function () {
                if (this.readyState !== 4) {
                    return;
                }

                if (this.status !== 200) {
                    return;
                }

                let response = JSON.parse(self._searchUrlXhr.responseText);
                let items = response.items ?? {};

                if (items.length === 0) {
                    self._noItemsNode.hidden = false;
                    self._searchingItemsNode.hidden = true;

                    return;
                }

                self._noItemsNode.hidden = true;
                let selectedValues = self._getValues();
                self._selectNode.querySelectorAll('option').forEach(optionNode => {
                    if (! selectedValues.includes(optionNode.value)) {
                        optionNode.remove();
                    }
                });

                let allowedIds = [];
                for (let i in items) {
                    let item = items[i];
                    let id = (item['id'] ?? i) + '';
                    allowedIds.push(id);

                    let existingOption = null;
                    for (let optionNode of self._selectNode.options) {
                        if (optionNode.value === id) {
                            existingOption = optionNode;

                            break;
                        }
                    }

                    if (existingOption) {
                        continue;
                    }

                    let optionNode = document.createElement('option');
                    optionNode.value = id;
                    optionNode.dataset.text = item.text;
                    optionNode.innerHTML = item.text;

                    self._selectNode.appendChild(optionNode);
                }

                self._searchingItemsNode.hidden = true;

                self._renderAvailableItems(allowedIds);
            };

            self._clearItems();
            self._searchUrlXhr.send('phrase=' + encodeURIComponent(self._searchNode.value) + '&group=' + encodeURIComponent(self._activeGroup));
        }, self._searchUrlTimeoutDelay);
    }

    _discoverItemsGroups() {
        for (let optionNode of this._selectNode.options) {
            optionNode._customSelectGroups = typeof optionNode.dataset.groups === 'string' ? optionNode.dataset.groups.split(';').map(group => {
                return group.trim();
            }).filter(group => {
                return Boolean(group);
            }) : null;
        }
    }

    _renderSelectedItems() {
        let self = this;
        self._selectedNode.innerHTML = '';
        for (let optionNode of self._selectNode.selectedOptions) {
            let selectedItemNode = document.createElement('div');
            selectedItemNode.classList.add('c-custom-select__selected-item');
            selectedItemNode.innerHTML = optionNode.dataset.text ? optionNode.dataset.text : optionNode.innerText;

            if (self._isMultiple) {
                let crossNode = document.createElement('button');
                crossNode.type = 'button';
                crossNode.classList.add('c-custom-select__selected-item-cross');
                crossNode.innerHTML = '╳';
                crossNode.addEventListener('click', event => {
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    optionNode.selected = false;
                    if (optionNode._customSelectItemNode) {
                        optionNode._customSelectItemNode.classList.remove('selected');
                    }
                    self._renderSelectedItems();

                    return false;
                });

                selectedItemNode.appendChild(crossNode);
            }

            self._selectedNode.appendChild(selectedItemNode);
        }

        if (! self._selectNode.selectedOptions.length) {
            let itemNode = document.createElement('div');
            itemNode.classList.add('c-custom-select__selected-item');
            itemNode.classList.add('c-custom-select__selected-item--select');
            itemNode.innerHTML = self._translate('SelectItems');
            self._selectedNode.appendChild(itemNode);
        }
    }

    _renderAvailableItems(allowedValues = null) {
        let self = this;
        let selectedValues = self._getValues();
        for (let optionNode of self._selectNode.options) {
            if (allowedValues && ! allowedValues.includes(optionNode.value)) {
                continue;
            }

            let itemNode = document.createElement('div')
            itemNode.classList.add('c-custom-select__items-item');

            if (selectedValues.includes(optionNode.value)) {
                itemNode.classList.add('selected');
            }

            itemNode.innerHTML = optionNode.dataset.text ? optionNode.dataset.text : optionNode.innerText;
            itemNode._customSelectOptionNode = optionNode;
            itemNode._customSelectLabel = self._sanitizeString(optionNode.innerText.replace(/(<([^>]+)>)/gi, ""));
            itemNode._customSelectGroups = optionNode._customSelectGroups;

            itemNode.addEventListener('click', () => {
                self._activateOption(optionNode, itemNode);
            });

            optionNode._customSelectItemNode = itemNode;
            self._itemsNode.appendChild(itemNode);
            self._itemsNodes.push(itemNode);
        }
    }

    _activateOption(optionNode, itemNode, event) {
        // check limit
        if (this._limit) {
            if (this._isMultiple && this._limit === 1) {
                for (let closingOptionNode of this._selectNode.options) {
                    closingOptionNode.selected = false;
                    closingOptionNode._customSelectItemNode.classList.remove('selected');
                }
                this._renderSelectedItems();
            } else if (this._selectNode.selectedOptions.length >= this._limit) {
                alert(this._translate('TheMaximumNumberOfSelectedItemsXHasBeenReached').replace('%', this._limit));
                return false;
            }
        }

        // activate option
        if (this._isMultiple) {
            optionNode.selected = ! optionNode.selected;
            if (itemNode) {
                itemNode.classList[optionNode.selected ? 'add' : 'remove']('selected');
            }
        } else {
            optionNode.selected = true;
            optionNode.setAttribute('selected', true);
            if (itemNode) {
                itemNode.classList.add('selected');
            }
            this.hideItems();
        }

        // setup selected attribute same as selected state
        for (let iteratingOptionNode of this._selectNode.options) {
            if (iteratingOptionNode.selected) {
                iteratingOptionNode.setAttribute('selected', true);
            } else {
                iteratingOptionNode.removeAttribute('selected');
            }
        }

        this._renderSelectedItems();
        this._selectNode.dispatchEvent(new Event('change'));
    }

    _updateOptionsAvailability() {
        let firstAvailableOptionNode = null;
        let visibleOptions = 0;

        for (let optionNode of this._selectNode.options) {
            let itemNode = optionNode._customSelectItemNode;

            // not in active group
            if (! this._isItemInActiveGroup(optionNode)) {
                optionNode.disabled = true;
                optionNode.selected = false;
                optionNode.removeAttribute('selected');

                if (itemNode) {
                    itemNode.hidden = true;
                    itemNode.classList.remove('selected');
                }

                continue;
            }

            // for search only
            if (
                ! this._sanitizedSearchPhrase
                && optionNode.dataset.visibility === 'search-only'
                && ! optionNode.hasAttribute('selected')
            ) {
                optionNode.disabled = true;
                optionNode.selected = false;
                optionNode.removeAttribute('selected');

                if (itemNode) {
                    itemNode.hidden = true;
                    itemNode.classList.remove('selected');
                }

                continue;
            }

            // on search
            if (this._sanitizedSearchPhrase && itemNode && itemNode._customSelectLabel.indexOf(this._sanitizedSearchPhrase) === -1) {
                optionNode.disabled = false;
                itemNode.hidden = true;

                continue;
            }

            // default visibility
            optionNode.disabled = false;
            if (itemNode) {
                itemNode.hidden = false;
                itemNode.classList[optionNode.selected ? 'add' : 'remove']('selected');
            }
            visibleOptions++;

            if (! firstAvailableOptionNode) {
                firstAvailableOptionNode = optionNode;
            }
        }

        // select first visible option
        // if (!this._isMultiple && ! this._selectNode.selectedOptions.length && firstAvailableOptionNode) {
        //     firstAvailableOptionNode.selected = true;
        //     if (firstAvailableOptionNode._customSelectItemNode) {
        //         firstAvailableOptionNode._customSelectItemNode.classList.add('selected');
        //     }
        // }

        // no items visibility control
        this._noItemsNode.hidden = visibleOptions;
    }

    _isItemInActiveGroup(itemNode) {
        if (this._activeGroup === null) {
            return true;
        }

        if (! itemNode._customSelectGroups) {
            return false;
        }

        return itemNode._customSelectGroups.includes(this._activeGroup) || itemNode._customSelectGroups.includes('*');
    }

    _getValues() {
        let values = [];
        for (let option of this._selectNode.selectedOptions) {
            values.push(option.value);
        }

        return values;
    }

    _sanitizeString(value) {
        value = value.toLowerCase();
        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        value = value.replace(/[\W_]+/g,'');

        // because of keyboard keys switch and i/y grammar issues
        value = value.replace(/z/g, 'y');
        value = value.replace(/y/g, 'i');

        return value;
    }

    _translate(key) {
        let self = this;

        if (typeof self.translations[document.documentElement.lang][key] === 'undefined') {
            return key;
        }

        return self.translations[document.documentElement.lang][key];
    }

    _swapKeyDownEvent() {
        if (! window['customSelectBoxesOpenedInstance']) {
            document.removeEventListener('keydown', this._swapKeyDownEvent);
        }

        window['customSelectBoxesOpenedInstance']._searchNode.focus();
    }

    _copyKeyDownEvt() {
        document.addEventListener('keydown', this._copyValueFromPreviousSelect);
    }

    _copyValueFromPreviousSelect() {

    }
}

CustomJsSelectBox.init();

document.addEventListener('LokiRequestEnd', function () {
    CustomJsSelectBox.init();
});